"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerState = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// polyfills for youtube-player (IE-11)
require("core-js/features/array/iterator");
const React = require("react");
const YouTubePlayerModule = require("youtube-player");
const youTubePlayer = YouTubePlayerModule.default || YouTubePlayerModule;
exports.PlayerState = {
    end: {
        value: 0,
        title: 'Ended',
    },
    play: {
        value: 1,
        title: 'Play',
    },
    pause: {
        value: 2,
        title: 'Pause',
    },
    progress: {
        title: 'Progress',
    },
};
class YouTubeWrapper extends React.Component {
    constructor() {
        super(...arguments);
        this.iframeContainer = React.createRef();
        this.internalPlayer = null;
        this.videoTrackingIntervalId = null;
        this.videoProgress = 0;
        this.videoTitle = null;
        this.progressThresholds = [25, 50, 75];
        this.createPlayer = () => {
            const playerOpts = {
                videoId: this.props.videoId,
                playerVars: this.props.playerVars,
            };
            this.internalPlayer = youTubePlayer(this.iframeContainer.current, playerOpts);
            // attach event handlers if there is onVideoEvent prop
            if (this.props.onVideoEvent) {
                this.internalPlayer.on('ready', this.onPlayerReady);
                this.internalPlayer.on('stateChange', this.onPlayerStateChange);
            }
        };
        this.onPlayerReady = event => {
            this.videoTitle = event.target.getVideoData().title;
        };
        this.onPlayerStateChange = (event) => {
            switch (event.data) {
                case exports.PlayerState.end.value:
                    if (typeof this.videoTrackingIntervalId === 'number' ||
                        this.videoTrackingIntervalId === null) {
                        clearInterval(this.videoTrackingIntervalId);
                    }
                    else {
                        clearInterval(this.videoTrackingIntervalId);
                    }
                    this.trackVideoEvent(exports.PlayerState.end.title, 100);
                    break;
                case exports.PlayerState.play.value:
                    this.updateVideoProgress(event);
                    this.videoTrackingIntervalId = setInterval(this.updateVideoProgress.bind(this, event), 1000);
                    this.trackVideoEvent(exports.PlayerState.play.title, this.videoProgress);
                    break;
                case exports.PlayerState.pause.value:
                    if (this.videoTrackingIntervalId) {
                        clearInterval(this.videoTrackingIntervalId);
                    }
                    this.trackVideoEvent(exports.PlayerState.pause.title, this.videoProgress);
                    break;
                default:
                    return;
            }
        };
        this.updateVideoProgress = event => {
            this.videoProgress = Math.floor((event.target.getCurrentTime() / event.target.getDuration()) * 100);
            this.trackProgressEvents();
        };
        this.trackProgressEvents = () => {
            const { onVideoEvent } = this.props;
            if (onVideoEvent) {
                this.progressThresholds = this.progressThresholds.filter(progressThreshold => {
                    if (this.videoProgress >= progressThreshold) {
                        this.trackVideoEvent(exports.PlayerState.progress.title, progressThreshold);
                        return false;
                    }
                    return true;
                });
            }
        };
        this.trackVideoEvent = (videoStatus, videoProgress) => {
            if (this.props.onVideoEvent) {
                const videoObject = {
                    videoStatus,
                    videoTitle: this.videoTitle,
                    videoProgress: `${videoProgress}%`,
                };
                this.props.onVideoEvent(videoObject);
            }
        };
    }
    componentDidMount() {
        this.createPlayer();
    }
    componentWillUnmount() {
        clearInterval(this.videoTrackingIntervalId);
        if (this.internalPlayer) {
            this.internalPlayer.destroy();
        }
    }
    render() {
        const { videoId, containerClassName } = this.props;
        return ((0, jsx_runtime_1.jsx)("div", { id: videoId, className: containerClassName, tabIndex: 0, ref: this.iframeContainer }));
    }
}
exports.default = YouTubeWrapper;
